
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCapacitor01 as ObiCapacitor01Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-capacitor-01.js';
 
 
 

 
 export const ObiCapacitor01 = createComponent({
   react: React,
   tagName: 'obi-capacitor-01',
   elementClass: ObiCapacitor01Element,
   events: {
     
   }
  });
 
 